import { atomWithStorage } from 'jotai/utils';
export const profileAtom = atomWithStorage('user_profile', {
    avatarDataUrl: undefined,
    title: '',
});
